import React from 'react'
import {
  Button,
  Grid,
  Modal,
  Stack,
  Typography,
  useMediaQuery,
} from '@mui/material'
import WarningIcon  from '@meprism/shared/src/assets/icons/warningicon.svg';
import { theme } from '../../../theme/DashboardTheme'
import { useNavigate } from 'react-router-dom'

interface AuthLetterRequiredModalProps {
  open: boolean
  setOpen: () => void
}

const AuthLetterRequiredModal = (props: AuthLetterRequiredModalProps) => {
  const navigate = useNavigate()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  const handleNavigate = () => {
    navigate('/dashboard/profile',{state: {index: 1, fromModal: true}})
    props.setOpen()
  }

  return (
    <Modal
      open={props.open}
      sx={{
        backdropFilter: 'blur(5px)',
        background: 'rgba(0, 0, 0, 0.01)',
      }}>
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        sx={{
          outline: 'none',
          position: 'absolute',
          top: '50%',
          left: '50%',
          maxWidth: '600px',
          transform: 'translate(-50%, -50%)',
          width: !isMobile ? '30%' : '80%',
          background: '#fff',
          p: {xs: 5, sm: 6, md: 8},
          borderRadius: '10px',
        }}>
        <Stack justifyContent="center" alignItems="center" flexDirection={'column'}>
          <img src={WarningIcon} style={{  width: '8vw', maxWidth: '100px', minWidth: '60px', height: 'auto', }} />
          <Typography 
            variant="h2" 
            mb={2} 
            mt={{xs: 4, sm: 4, md: 5, lg: 4}} 
            textAlign="center"
            sx={{
              fontFamily: 'InterBold',
              fontSize: {xs: 18, md: 22, lg: 24},
              fontWeight: 600,
              lineHeight: {xs: 1, md: 1.2, lg: 1.5},
            }}>
            Street Address Required!
          </Typography>
          <Typography 
            textAlign="center" 
            color={'#615F6B'}
            sx={{
              fontFamily: 'InterRegular',
              mb: {xs: 2, sm: 3, md: 4},
              fontSize: {xs: 12, md: 15, lg: 16},
              lineHeight: {xs: 1.2, md: 1.2, lg: 1.5},
            }}>
            We need your street address to start the opt-out process
          </Typography>
        </Stack>
        <Grid item xs={12} sm={12} justifyContent="center" display="flex">
          <Button
            variant={'contained'}
            color={'darkPurple'}
            onClick={handleNavigate}
            sx={{
              width: {xs: '90%', sm: '90%', md: '70%', lg: '60%'},
              borderRadius: '10px',
              fontSize: {xs: 12, sm: 10, md: 12, lg: 15},
              boxShadow: 'unset',
              border: '2px solid #C67EFF',
              background: 'transparent',
              color: '#C67EFF',
              fontFamily: 'InterBold',
              '&.Mui-disabled': {
                background: 'transparent',
                color: '#C67EFF',
              },
              ':hover': {
                background: 'transparent',
                color: '#C67EFF',
              },
            }}>
            Add Street Address
          </Button>
        </Grid>
      </Grid>
    </Modal>
  )
}

export default AuthLetterRequiredModal 